import React from 'react';
import PropTypes from 'prop-types';
import { BLOCKS } from '@contentful/rich-text-types';

import RichText from '../RichText';

import { Collection, Icon } from './styles';

const TextIconCollection = ({ data, className = '' }) => {
  if (!data) return null;

  const rates = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_, children) => <span>{children}</span>,
    },
  };

  return (
    <Collection className={`${className} no-bullets`}>
      {data.map(({ id, iconDam, text, heading, description }) => {
        return (
          <React.Fragment key={id}>
            {className && className.includes('card-features') ? (
              <li
                key={id}
                className={!iconDam && !text ? 'rates' : ''}
                data-aos={
                  className.includes('left') ? 'fade-right' : 'fade-left'
                }
              >
                {heading && description && (
                  <>
                    {iconDam && (
                      <Icon
                        src={iconDam.asset.localImage.publicURL}
                        alt={iconDam.altText || ''}
                        role="presentation"
                      />
                    )}
                    <RichText document={heading} options={rates} />
                    <RichText document={description} />
                  </>
                )}
                {iconDam && text && (
                  <>
                    <Icon
                      src={iconDam.asset.localImage.publicURL}
                      alt={iconDam.altText || ''}
                      role="presentation"
                    />
                    <RichText document={text} />
                  </>
                )}
              </li>
            ) : (
              <li key={id} className={!iconDam && !text ? 'rates' : ''}>
                {heading && description && (
                  <>
                    {iconDam && (
                      <Icon
                        src={iconDam.asset.localImage.publicURL}
                        alt={iconDam.altText || ''}
                        role="presentation"
                      />
                    )}
                    <RichText document={heading} options={rates} />
                    <RichText document={description} />
                  </>
                )}
                {iconDam && text && (
                  <>
                    <Icon
                      src={iconDam.asset.localImage.publicURL}
                      alt={iconDam.altText || ''}
                      role="presentation"
                    />
                    <RichText document={text} />
                  </>
                )}
              </li>
            )}
          </React.Fragment>
        );
      })}
    </Collection>
  );
};

TextIconCollection.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  className: PropTypes.string,
};

export default TextIconCollection;
